var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.textArr),function(item,index){return _c('div',{key:index},[_vm._v(_vm._s(item)+" "),(item == '')?_c('br'):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }